module.exports = __webpack_public_path__ + "static/media/icon-child-female.7e43a8b8.svg";